import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { errorMessage } from '../api/client';
import { Field } from '../components/Field';
import { Notice } from '../components/Notice';
import { useSession } from '../session/SessionContext';

export function LoginPage() {
  const { status, login } = useSession();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  if (status === 'connecte') return <Navigate to="/postes" replace />;

  const onSubmit = (event: React.FormEvent): void => {
    event.preventDefault();
    setBusy(true);
    setError(null);
    login(email, password)
      .then(() => navigate('/postes', { replace: true }))
      .catch((cause: unknown) => setError(errorMessage(cause)))
      .finally(() => setBusy(false));
  };

  return (
    <div className="connexion">
      <div className="connexion__panneau">
        <div className="connexion__marque">
          <h1>DiagFlow</h1>
          <p>Suivi du parc informatique</p>
        </div>

        <form className="panneau" onSubmit={onSubmit}>
          <div className="panneau__entete">
            <span className="panneau__titre">Connexion</span>
          </div>
          <div className="panneau__corps pile pile--serree">
            {error !== null && <Notice tone="erreur">{error}</Notice>}

            <Field label="Adresse électronique">
              <input
                type="email"
                value={email}
                autoComplete="username"
                required
                autoFocus
                onChange={(event) => setEmail(event.target.value)}
              />
            </Field>

            <Field label="Mot de passe">
              <input
                type="password"
                value={password}
                autoComplete="current-password"
                required
                onChange={(event) => setPassword(event.target.value)}
              />
            </Field>

            <button type="submit" className="bouton bouton--primaire" disabled={busy}>
              {busy ? 'Connexion…' : 'Se connecter'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
